// /orgs/$orgSlug/projects/$projectId — LAYOUT route for everything
// project-scoped (shots, playlists, dashboard, settings, …).
//
// Same rule as `orgs.$orgSlug.tsx`: children nest here, so this must
// render an <Outlet/> or child navigations go nowhere. The project
// landing page (shot list) lives in
// `orgs.$orgSlug.projects.$projectId.index.tsx`.

import { createFileRoute, Link, Outlet } from '@tanstack/react-router';

import { ApiError, apiErrorMessage } from '../api/client';

export const Route = createFileRoute('/orgs/$orgSlug/projects/$projectId')({
  component: Outlet,
  errorComponent: ProjectRouteError,
});

function ProjectRouteError({ error }: { error: unknown }): React.JSX.Element {
  const isApi = error instanceof ApiError;
  const status = isApi ? error.status : null;
  const heading =
    status === 404
      ? 'Project not found'
      : status === 403
        ? 'You don’t have access to this project'
        : 'Something went wrong loading this project';
  const body = apiErrorMessage(error, 'Try again, or pick a different project from the organization page.');

  return (
    <div className="mx-auto max-w-2xl py-7">
      <p className="text-text-faint text-11 mb-2 uppercase tracking-wider">
        Error
      </p>
      <h1 className="text-text text-28 mb-3 font-semibold">{heading}</h1>
      <p className="text-text-muted mb-5 text-13">{body}</p>
      <Link
        to="/"
        className="bg-accent text-accent-fg border-border-strong rounded-2 hover:bg-accent-hi inline-block border px-3 py-2 text-13 transition-colors"
      >
        Back to home
      </Link>
    </div>
  );
}
